import axios from 'axios';
import * as CONFIG from '../config/index';
export const COMMENT_API_URL = `${CONFIG.API_URL}/commentation`;

export const getComments = async (ipId) => {
  const res = await axios.get(`${COMMENT_API_URL}?ipId=${ipId}&type=0`)
  return res.data.data;
}

export const createComment = async (comment) => {
  // comment (contentComment, contentId, attachedFile, parentId, isFeedBack)
  await axios.post(`${COMMENT_API_URL}`, comment)
}

export const updateComment = async (comment) => {
  await axios.put(`${COMMENT_API_URL}`, comment)
}

export const deleteComment = async (id) => {
  await axios.delete(`${COMMENT_API_URL}?commentId=${id}`)
}



// WEBPACK FOOTER //
// ./src/common/comment.js